import styled from 'styled-components'

import LoadingIcon from './LoadingIcon'

const BaseBtn = (props) => {
  const {
    loading = false,
    disabled,
    icon,
    tag,
    color,
    bg_color,
    border_color,
    onClick,
  } = props

  const onClickItem = () => {
    onClick(tag)
  }

  let click
  let css
  if (!disabled) {
    click = onClickItem
    css = 'click'
  }

  const icon_content =
    loading && !disabled ? (
      <LoadingIcon loading={true} />
    ) : icon ? (
      <Icon>{icon}</Icon>
    ) : undefined

  return (
    <PageView
      onClick={click}
      className={css}
      color={color}
      bg_color={bg_color}
      border_color={border_color}
    >
      {icon_content}
    </PageView>
  )
}

const PageView = styled.span`
  border-radius: 20px;
  padding: 6px 8px;
  width: 35px;
  height: 35px;

  color: ${(props) => props.color};
  background-color: ${(props) => props.bg_color};
  border: 1px solid ${(props) => props.border_color};

  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const Icon = styled.span`
  font-size: 14px;
  cursor: pointer;
`

export default BaseBtn
